import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from "sweetalert2";
import PoServices from "../../../services/PoServices";
import RequestServies from "../../../services/RequestServices";

const MrvEditModal = ({ show, handleClose, run, admin }) => {
    const initialFormValues = {
        store: '',
        supplier: '',
        billingTitle: '', // ✅ new field
        billingNo: '',
        billingDate: '',
        image: null,
        itemCount: '',
        otherCharges: 0,   // ✅ New field
        totalAmount: 0,    // ✅ New field
        status: 'open'
    };

    const [formValues, setFormValues] = useState(initialFormValues);
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        if (show) {
            PoServices.activeSuppliers()
                .then((res) => setSuppliers(res.data || []))
                .catch((err) => {
                    console.error("Failed to load suppliers", err);
                    Swal.fire("Error", "Failed to fetch suppliers", "error");
                });
        }
    }, [show]);

    useEffect(() => {
        if (admin) {
            setFormValues({
                store: admin.store?._id || '',
                supplier: admin.supplier?._id || '',
                billingNo: admin.billingNo || '',
                billingTitle: admin.billingTitle || '', // ✅ prefill billing title
                billingDate: admin.billingDate ? admin.billingDate.split("T")[0] : '',
                itemCount: admin.itemCount || '',
                image: null,
                otherCharges: admin.otherCharges || 0,   // ✅ Prefill
                totalAmount: admin.totalAmount || 0,     // ✅ Prefill
                status: admin.status || 'open', // ✅ Prefill MRV status
            });

            if (admin.image) {
                setPreviewImage(`https://indigoinfra.in/img/mrv/${admin.image}`);
            }
        }
    }, [admin]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setPreviewImage(reader.result);
            reader.readAsDataURL(file);
            setFormValues({ ...formValues, image: file });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await RequestServies.mrvDeatilUpdate(admin._id, formData);
            Swal.fire("Success", "MRV updated successfully!", "success");
            handleClose();
            run && run(prev => prev + 1);
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Failed to update MRV!", "error");
        }
    };

    return (
        <Modal className="fade" show={show} onHide={handleClose}>
            <form onSubmit={handleSubmit}>
                <Modal.Header>
                    <Modal.Title>
                        <i className="fas fa-edit"></i> Edit MRV Details
                    </Modal.Title>
                    <Button variant="" className="btn-close" onClick={handleClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            {/* Store */}
                            <Col md="12">
                                <label>Store</label>
                                <input
                                    type="text"
                                    value={admin?.store?.name || ""}
                                    disabled
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Supplier */}
                            <Col md="12 mt-3">
                                <label>Supplier</label>
                                <select
                                    name="supplier"
                                    className="form-control form-control-sm"
                                    value={formValues.supplier}
                                    onChange={handleInputChange}
                                    disabled={admin?.status !== 'open'} // ✅ Enable only if status is 'open'
                                >
                                    <option value="">Select a Supplier</option>
                                    {suppliers.map((sup) => (
                                        <option key={sup._id} value={sup._id}>{sup.name}</option>
                                    ))}
                                </select>
                            </Col>
                            {/* Billing Title */}
                            <Col md="6 mt-3">
                                <label>Bill Title (e.g., RCT-25)</label>
                                <input
                                    type="text"
                                    name="billingTitle"
                                    value={formValues.billingTitle}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                    placeholder="Enter Bill Title (optional)"
                                />
                            </Col>



                            {/* Bill No */}
                            <Col md="6 mt-3">
                                <label>Bill Number</label>
                                <input
                                    type="number"
                                    name="billingNo"
                                    value={formValues.billingNo}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Bill Date */}
                            <Col md="6 mt-3">
                                <label>Bill Date</label>
                                <input
                                    type="date"
                                    name="billingDate"
                                    value={formValues.billingDate}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Item Count */}
                            <Col md="6 mt-3">
                                <label>Item Count</label>
                                <input
                                    type="number"
                                    name="itemCount"
                                    value={formValues.itemCount}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Other Charges */}
                            <Col md="6 mt-3">
                                <label>Other Charges</label>
                                <input
                                    type="number"
                                    name="otherCharges"
                                    value={formValues.otherCharges}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Total Amount */}
                            <Col md="6 mt-3">
                                <label>Total Amount</label>
                                <input
                                    type="number"
                                    name="totalAmount"
                                    value={formValues.totalAmount}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                />
                            </Col>

                            {/* Image */}
                            <Col md="12 mt-3">
                                <label>Upload Bill Image</label>
                                <input
                                    type="file"
                                    className="form-control form-control-sm"
                                    onChange={handleFileChange}
                                />
                                {previewImage && (
                                    <div className="file-preview text-center mt-2">
                                        <img src={previewImage} alt="Preview" className="img-fluid" />
                                    </div>
                                )}
                            </Col>

                            <Col md='12 mt-3'>
                                <label>Status</label>
                                <select
                                    name="status"
                                    className="form-control form-control-sm"
                                    value={formValues.status}
                                    onChange={(e) => {
                                        // ✅ Allow only selecting "forceClosed"
                                        if (e.target.value === 'forceClosed') {
                                            handleInputChange(e);
                                        } else {
                                            // Prevent other status selections
                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Not Allowed',
                                                text: 'You can only change status to Force Closed.',
                                                confirmButtonText: 'OK',
                                            });
                                        }
                                    }}
                                    disabled={admin?.status === 'forceClosed' || admin?.status === 'close' || admin?.status === 'submit'} // Disable only if already force closed
                                >
                                    <option value="open">Open</option>
                                    <option value="submit">Submit</option>
                                    <option value="close">Close</option>
                                    <option value="forceClosed">Force Closed</option>
                                </select>

                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" onClick={handleClose}>Close</Button>
                    <Button variant="primary" type="submit">Save changes</Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default MrvEditModal;
